module.exports = __webpack_public_path__ + "static/img/float-service.8c14407.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/float-service.webp
// module id = YSUX
// module chunks = 3